import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { useState } from "react";
import { useSelector } from "react-redux";

export default function CustomDatePicker({
  name,
  onChange,
  width,
  disabled,
  views,
  defaultValue,
  placeholder,
  maxDateTime,
  minDateTime,
}) {
  const themechange = useSelector((state) => state.themedata.theme);
  const currentDate = dayjs();
  //const maxDateTime = currentDate.add(0, "day");
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const handleDateTimeChange = (newValue) => {
    setSelectedDateTime(newValue);
    onChange(newValue, name);
  };

  React.useEffect(() => {
    setSelectedDateTime(defaultValue ? defaultValue : null);
  }, [defaultValue]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DateTimePicker"]}>
        <DateTimePicker
          name={name}
          defaultValue={selectedDateTime}
          // defaultValue={defaultValue ? defaultValue : placeholder ? placeholder : dayjs(new Date())}
          // {defaultValue? defaultValue={defaultValue} : null}
          value={selectedDateTime}
          // placeholder={placeholder?placeholder:null}
          onChange={handleDateTimeChange}
          disabled={disabled != null ? disabled : false}
          sx={{
            // width: '617px',
            // height: '36px',
            fontSize: "16px",
            // padding: "0px 10px",
            "& .MuiInput-root .MuiInputBase-input": {
              padding: 0,
            },
            "& .MuiStack-root": {
              padding: 0,
            },
            "& .MuiPaper-root .MuiPickersPopper-paper": {
              backgroundColor: themechange === "light" ? "#efefef" : "#000000",
            },
          }}
          PopperProps={{
            sx: { "&.MuiPickersPopper-root": { border: "4px solid red" } },
          }}
          slotProps={{
            textField: {
              variant: "standard",
              sx: {
                overflow: "hidden",
                // width: width ? `${width}px` : "617px",
                height: "100%",
                padding: "0px",
                fontSize: "16px",
                color: themechange === "light" ? "#3c3c3c" : "#ffffff",
                "& .MuiInputBase-input:focus": {
                  color: "#008CD7",
                },
                "& .MuiInputBase-root": {
                  fontFamily: "Roboto",
                  fontSize: "16px",
                  fontWeight: "700",
                  color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
                  //color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                  width: width ? `${width}px` : "617px",
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor:
                    themechange === "light" ? "#C1C1C1" : "#3C3C3C",
                  //WebkitBorderFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',
                },
                // '& .MuiInput-underline.Mui-disabled':{
                //     color: themechange === 'light' ? '#C1C1C1' : '#pink',
                // },
                "& .MuiInputBase-root .MuiInput-root .MuiInput-underline": {
                  color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
                  borderBottom: `1px solid ${
                    (disabled != null ? disabled : false) == true
                      ? themechange === "light"
                        ? "#C1C1C1"
                        : "#3C3C3C"
                      : themechange === "light"
                        ? "#3c3c3c"
                        : "#c1c1c1"
                  }`,
                },
                "& .MuiSvgIcon-root": {
                  color:
                    (disabled != null ? disabled : false) == true
                      ? themechange === "light"
                        ? "#C1C1C1"
                        : "#3C3C3C"
                      : themechange === "light"
                        ? "#3c3c3c"
                        : "#c1c1c1",
                },
                "& .MuiInputBase-root::before": {
                  borderBottom: `1px solid ${
                    (disabled != null ? disabled : false) == true
                      ? themechange === "light"
                        ? "#C1C1C1"
                        : "#3C3C3C"
                      : themechange === "light"
                        ? "#3c3c3c"
                        : "#c1c1c1"
                  }`,
                },
                "& .MuiInputBase-root::after": {
                  borderBottom: "2px solid #008CD7",
                },
              },
              // placeholder:{placeholder}
            },
            dialog: {
              sx: {
                backgroundColor:
                  themechange === "light" ? "#efefef" : "#000000",
              },
            },
          }}
          maxDateTime={maxDateTime ? maxDateTime : null}
          minDateTime={minDateTime ? minDateTime : null}
          timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
          ampm={false}
          views={views}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
